import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Chip, Typography } from "@mui/material";
import CustomModal from "components/atoms/CustomModal";
import { grey } from "@mui/material/colors";
import ModalContent from "components/molecules/visitDetailsTab/ModalContent";
import moment from "moment";

const Row = ({ row, handleClick }) => {
  return (
    <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell component="th" scope="row" align="left">
        {moment(new Date(row?.updatedAt)).format("MMM Do, YYYY : hh:mm a")}
      </TableCell>
      <TableCell align="left">{row?.noteBy?.fullName}</TableCell>

      <TableCell align="left">
        <Button
          variant="text"
          color="secondary"
          sx={{ textDecoration: "underline", fontSize: "12px" }}
          onClick={() => handleClick(row)}
        >
          View
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default function DoctorsNoteTable({ data, fromSummary = false }) {
  const modalRef = React.useRef(null);
  const [content, setcontent] = React.useState();

  const handleClick = (row) => {
    setcontent(row);
    modalRef?.current?.handleToggle();
  };

  //if there is comment in the assessmentLog array, then its a normal message else its doctors note,
  // since assesment log contains both doctors note and and conversations in that visit
  const notesWithTopic = data?.length
    ? data.filter((log) => !log?.note?.comment)
    : [];

  return (
    <>
      {notesWithTopic.length ? (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow
                sx={{ backgroundColor: !fromSummary ? "background.light" : "" }}
              >
                <TableCell sx={{ fontWeight: "bold" }} align="left">
                  Date
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }} align="left">
                  Doctor
                </TableCell>

                <TableCell sx={{ fontWeight: "bold" }} align="left">
                  Notes
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {notesWithTopic?.map((row) => (
                <Row key={row._id} row={row} handleClick={handleClick} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Paper sx={{ p: 2 }}>
          <Typography>No data</Typography>
        </Paper>
      )}

      <CustomModal
        ref={modalRef}
        childrenContSx={{
          p: 4,

          width: {
            xs: "95%",
            sm: "75vw",
            lg: "70vw",
          },
        }}
      >
        <ModalContent
          item={content}
          handleClose={() => modalRef?.current?.handleToggle()}
        />
      </CustomModal>
    </>
  );
}
